import { Tooltip } from 'antd';
import React, { useState } from 'react';
import { styles } from '../styles';
import DropdownEditData from './DropdownEditData';
import Input from './Input';

const Column = ({
  index,
  col,
  editorInfo,
  editTableData,
  handleEditTableData,
  onUpdate,
  selectedColumn,
  isPieOrPolarChart,
}) => {
  const classes = styles();

  const [isOpenDropdown, setIsOpenDropDown] = useState(false);

  const handleOpenChange = (open) => {
    setIsOpenDropDown(open);
  };

  const colHeader = (
    <span
      className={`${isOpenDropdown && classes.dropdownOpen}`}
      onClick={() => handleEditTableData(true, false, index)}
    >
      {col}
    </span>
  );

  return (
    <th
      key={index}
      className={`${classes.header} ${classes.colHeader} ${
        selectedColumn === index && isPieOrPolarChart ? 'selected' : ''
      }`}
    >
      {editTableData.isColHead && editTableData.index === index ? (
        <Input data={col} editorInfo={editorInfo} editTableData={editTableData} onUpdate={onUpdate} />
      ) : (
        <>
          {selectedColumn === index && isPieOrPolarChart ? (
            <Tooltip
              title={<div style={{ textAlign: 'center' }}>This column is currently selected to draw the chart</div>}
              mouseLeaveDelay={0}
            >
              {colHeader}
            </Tooltip>
          ) : (
            colHeader
          )}
          <DropdownEditData
            index={index}
            type="col"
            editorInfo={editorInfo}
            onUpdate={onUpdate}
            handleOpenChange={handleOpenChange}
            isPieOrPolarChart={isPieOrPolarChart}
          />
        </>
      )}
    </th>
  );
};

export default Column;
